<div class='modal-header'
     [ngSwitch]='dialogMode' (click)='$event.stopPropagation()'>
  <ng-container *ngSwitchCase='"CREATE"'>
    <h4 class='modal-title'>
      {{'TITLE.NEW_APP_ASSESSMENT' | translate}}
    </h4>
  </ng-container>

  <ng-container *ngSwitchCase='"EDIT"'>
    <h4 class='modal-title'>
      {{'TITLE.EDIT_APP_ASSESSMENT' | translate}}
    </h4>
  </ng-container>
</div>

<div class='modal-body' (click)='$event.stopPropagation()'>
  <ng-container *ngIf='formGroup'>
    <form [formGroup]='formGroup'>
      <div class='form-group'>
        <pt-input-text
          [controlName]='"name"'
          formControlName='name'
          [label]="'LABELS.NAME' | translate"
          [validators]='[REQUIRED]'
        ></pt-input-text>

        <pt-input-text-area
          [minRow]='descriptionMinRows'
          [inputId]='"description"'
          formControlName='description'
          [label]="'LABELS.DESCRIPTION' | translate"
        ></pt-input-text-area>

        <pt-input-text
          [controlName]='"application"'
          formControlName='application'
          [label]="'LABELS.APPLICATION' | translate"
        ></pt-input-text>


        <ng-container *ngIf='simplified'>
          <pt-input-label
            [label]='"LABELS.RISK" | translate'
            [isRequired]='true'
          ></pt-input-label>
          <div class='w-100 font-12 ps-2'>
            <div class='d-flex align-items-baseline justify-content-between'>
              <pt-input-label
                [label]="'LABELS.R' | translate"
              ></pt-input-label>
              <pt-input-select
                [controlName]='"r"'
                formControlName='r'
                [options]='inputRiskEvaluationLevelSelectOptions'
              ></pt-input-select>
            </div>

            <div class='d-flex align-items-baseline justify-content-between'>
              <pt-input-label
                [label]="'LABELS.I' | translate"
              ></pt-input-label>
              <pt-input-select
                [controlName]='"i"'
                formControlName='i'
                [options]='inputRiskEvaluationLevelSelectOptions'
              ></pt-input-select>
            </div>

            <div class='d-flex align-items-baseline justify-content-between'>
              <pt-input-label
                [label]="'LABELS.D' | translate"
              ></pt-input-label>
              <pt-input-select
                [controlName]='"d"'
                formControlName='d'
                [options]='inputRiskEvaluationLevelSelectOptions'
              ></pt-input-select>
            </div>
          </div>

          <pt-input-label
            [label]="'LABELS.ATTACHED_DOCUMENTS' | translate"
          ></pt-input-label>
          <pt-input-attachment
            [showDelete]='true'
            [showDownload]='false'
            [attachments]='formGroup?.controls?.attachments?.value'
            [noAttachmentMessage]="'MESSAGE.ATTACHMENT_WITHOUT_NAME' | translate"
            (attachAction)='onAttachAction($event)'
            (deleteAttachment)='onDeleteAttachment($event)'
          ></pt-input-attachment>
          <div class='error-message mt-1'>
            <small *ngIf='showAttachError'>
              {{"MESSAGE.ALREADY_ATTACH" | translate}}
            </small>
          </div>
        </ng-container>
      </div>
    </form>
  </ng-container>
</div>

<div class='modal-footer' (click)='$event.stopPropagation()'>
  <button type='button' class='btn btn-primary btn-sm'
          [disabled]='formGroup?.invalid'
          (click)='confirm(); $event.stopPropagation()'>
    <ng-container [ngSwitch]='dialogMode'>
      <ng-container *ngSwitchCase='"CREATE"'>
        {{ 'BUTTON.CONFIRM' | translate }}
      </ng-container>
      <ng-container *ngSwitchCase='"EDIT"'>
        {{ 'BUTTON.SAVE' | translate }}
      </ng-container>
    </ng-container>
  </button>
  <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
          (click)='activeModal.close(false); $event.stopPropagation()'>
    {{ 'BUTTON.CANCEL' | translate }}
  </button>
</div>
